import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import InputField from "../../../../Components/Masters/InputField";
import { Box, Button, Typography } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { get, put } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import { validateNumberInput } from "../../../../utils/validateFields";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import { restructureData } from "../../../../utils/restructureData";
import StaticColumn from "./StaticColumn";
import ReviewBox from "../../../../Components/Common/ReviewBox";

import { currentYear } from "../../../../utils/generateYearRanges";
import { validateLeadershipTable } from "../../../../utils/validateTable";

const GRI303_4 = ({ hide }) => {
  const [table, setTable] = useState([]);
  const [table1, setTable1] = useState([]);
  const [table2, setTable2] = useState([]);
  const [defaultUnit, setDefaultUnit] = useState("");
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  const fields = [
    {
      fieldName: "waterType",
      title: "Water Withdrawal",
      type: "text",
      placeholder: "Enter Text",
      width: "9rem",
    },
    {
      fieldName: "range",
      title: "Range",
      type: "percentage",
      width: "9rem",
      placeholder: "Enter Range",
    },
    {
      fieldName: "response",
      title: "Response",
      type: "text",
      width: "8rem",
      placeholder: "Enter Text",
    },
    {
      fieldName: "quantity",
      title: "Quantity",
      type: "number",
      width: "7rem",
      placeholder: "Number",
    },
    // {
    //   fieldName: "unit",
    //   title: "Unit",
    //   type: "select",
    //   options: ["m3", "megaliters"],
    //   width: "8rem",
    //   placeholder: "Select",
    // },
    {
      fieldName: "remark",
      title: "Remark",
      type: "text",
      width: "10rem",
      placeholder: "Enter Text",
    },
  ];

  const inputData = [
    [
      {
        fieldName: "totalWaterDischargeByDestination",
        // title:
        //   "Breakdown of total water withdrawal by the following types of destination (include all facility)",
        type: "array",
        tables: table,
        setTables: setTable,
        defaultSegments: [
          "Surface Water",
          "Groundwater/Seawater",
          "Produced Water",
          "Sent to Other Organization",
        ],
        errorField:"totalDischargeQuantity",
        paramater: "destination",
        fields: [
          {
            fieldName: "destination",
            title: "Destination",
            type: "text",
            placeholder: "Enter Text",
            width: "22%",
          },
          {
            fieldName: "response",
            title: "Response",
            type: "text",
            width: "18%",
            placeholder: "Enter Text",
          },
          {
            fieldName: "quantity",
            title: "Quantity",
            type: "number",
            width: "15%",
            placeholder: "Enter Number",
          },
          // {
          //   fieldName: "unit",
          //   title: "Unit",
          //   type: "select",
          //   options: ["m3", "megaliters"],
          //   width: "15%",
          //   placeholder: "Select",
          // },
          {
            fieldName: "remark",
            title: "Remark",
            type: "text",
            width: "15%",
            placeholder: "Enter Text",
          },
        ],
      },
    ],
    [
      {
        fieldName: "waterDischargeByCategory",
        title:
          "Breakdown of total water discharge to all areas in kiloliters by the following categories:",
        type: "array",
        letter: "b.",
        tables: table1,
        errorField:"totalDischargeCategoryQuantity",
        setTables: setTable1,
        defaultSegments: ["Freshwater", "Other Water"],
        defaultSegments2: ["< 1000mg/L TDS", "> 1000mg/L TDS"],
        paramater: "waterType",
        paramater2: "range",
        fields: fields,
      },
    ],
    [
      {
        fieldName: "table",
        type: "array",
        tables: table2,
        setTables: setTable2,
        errorField:"totalQuantity",
        defaultSegments: ["Freshwater", "Other Water"],
        defaultSegments2: ["< 1000mg/L TDS", "> 1000mg/L TDS"],
        paramater: "waterType",
        paramater2: "range",
        fields: fields,
      },
    ],
  ];

  const rowField = [
    { fieldName: "total", title: "Total", type: "number", width: "13rem" },
    // { fieldName: "unit", title: "Unit", type: "text", width: "12rem" },
    // {
    //   fieldName: "quantity",
    //   title: "Quantity",
    //   type: "number",
    //   width: "9rem",
    // },
    // { fieldName: "remark", title: "Remark", type: "text", width: "18rem" },
  ];

  const questionData = [
    {
      fieldName: "prioritySubstancesDefinitionCriteria",
      title:
        "i. How were priority substances of concern defined, and were any international standards, authoritative lists, or criteria used?",
      type: "text",
      // letter: "i.",
    },
    {
      fieldName: "dischargeLimitsSettingApproach",
      title:
        "ii. What approach was taken for setting discharge limits for priority substances of concern?",
      type: "text",
      // letter: "ii.",
    },
    {
      fieldName: "nonComplianceIncidentsDuring",
      title:
        "iii. How many incidents of non-compliance with discharge limits occurred during the reporting period?",
      type: "number",
      // letter: "iii.",
    },
    {
      fieldName: "contextualInformation",
      title:
        "e. Provide any contextual information necessary for understanding how the data have been compiled, including details about the standards, methodologies, and assumptions used.",
      type: "text",
      // letter: "e.",
    },
  ];

  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [tabErrors, setTabErros] = useState({});
  const [data, setData] = useState([]);
  const [formData, setFormData] = useState({ contextualInformation: "" });
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(`/gri/get?Id=${id}&type=GRI300`);
      if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false) setDisabled(true);
      const res1 = res?.data?.data?.GRI300?.waterDischarge;
      setData(res1);
      setDefaultUnit(
        res?.data?.data?.GRI300?.sharedResource?.waterInteraction?.[0]?.unit
      );
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    setFormData({
      totalWaterAllareas: {
        total: data?.totalWaterAllareas?.total || "",
        unit: data?.totalWaterAllareas?.unit || defaultUnit || "",
        // quantity: data?.totalWaterAllareas?.quantity || "",
        // remark: data?.totalWaterAllareas?.remark || "",
      },
      //c I
      waterDischargeToWaterStressAreas: {
        total: data?.waterDischargeToWaterStressAreas?.total || "",
        unit: data?.waterDischargeToWaterStressAreas?.unit || defaultUnit || "",
        // quantity: data?.waterDischargeToWaterStressAreas?.quantity || "",
        // remark: data?.waterDischargeToWaterStressAreas?.remark || "",
      },
      // d
      checklistForPriority: {
        prioritySubstancesDefinitionCriteria:
          data?.checklistForPriority?.prioritySubstancesDefinitionCriteria ||
          "",
        dischargeLimitsSettingApproach:
          data?.checklistForPriority?.dischargeLimitsSettingApproach || "",
        nonComplianceIncidentsDuring:
          data?.checklistForPriority?.nonComplianceIncidentsDuring || "",
      },
      // e
      contextualInformation: data?.contextualInformation || "",
    });
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "nonComplianceIncidentsDuring" && !validateNumberInput(value))
      return;
    if (name === "contextualInformation")
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    else
      setFormData((prev) => ({
        ...prev,
        checklistForPriority: { ...prev.checklistForPriority, [name]: value },
      }));
  };

  const handleRowChange = (name, value, index, type) => {
    if (type === "number" && !validateNumberInput(value)) return;
    if (index === 0)
      setFormData((prev) => ({
        ...prev,
        totalWaterAllareas: { ...prev.totalWaterAllareas, [name]: value },
      }));
    else
      setFormData((prev) => ({
        ...prev,
        waterDischargeToWaterStressAreas: {
          ...prev.waterDischargeToWaterStressAreas,
          [name]: value,
        },
      }));
  };

  const handleSubmit = async () => {
 let v1=validateLeadershipTable(inputData[0], table, setTabErros,"totalWaterDischargeByDestination","destination",);
      let v2 = validateLeadershipTable(inputData[1], table1, setTabErros,"waterDischargeByCategory","waterType","range");
      let v3 = validateLeadershipTable(inputData[2], table2, setTabErros,"table","waterType","range");

      console.log(v1,v2,v3,"check")
      if (!v1 || !v3 ||!v2) return;    
      if (!disabled) {
      let transformedData2 = {
        waterDischarge: {
          totalWaterAllareas: {
            ...formData?.totalWaterAllareas,
            ...restructureData(table),
          },
          ...restructureData(table1),
          waterDischargeToWaterStressAreas: {
            ...formData?.waterDischargeToWaterStressAreas,
            ...restructureData(table2),
          },
          checklistForPriority: formData?.checklistForPriority,
          contextualInformation: formData?.contextualInformation,
        },
        type: "GRI300",
        submitted303_4: true,
      };

      try {
        const res = await put(`/gri/update?Id=${id}`, transformedData2);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success", 
        });
        navigate(`/gri/gri300/303-5/${id}`);
      } catch (error) {
        setsnackOpen({
          open: true,
          message: error.data.message,
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/gri300/303-5/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      {!hide && (
        <p className={styles.section_heading}>303 : Water & Effluents</p>
      )}
      <p
        className={styles.main_heading}
        style={{ marginBottom: hide ? "-1rem" : "0" }}
      >
        303-4 : water DISCHARGE
      </p>
      {/* a */}
      <p className={styles.ques_heading} style={{ marginTop: "1rem" }}>
        a. Total water discharge to all areas in kiloliters.
      </p>
      {inputData?.map((el, i) => (
        <Box sx={{ mt: hide ? "-2rem" : "2rem" }}>
          {i === 2 && (
            <>
              <p className={styles.ques_heading} style={{ marginTop: "3rem" }}>
                c.  Total water discharge to all areas with water stress in
                kiloliters{" "}
              </p>
            </>
          )} 
          {(i === 0 || i === 2) && (
            <Box sx={{ display: "flex", mt: 1, gap: 3, ml: 2.5 }}>
              {rowField?.map((row) => (
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontStyle: "inter",
                      fontFamily:"inter",
                      fontSize: "15px",
                      lineHeight: "22px",
                    }}
                  >
                    {row?.title}
                  </Typography>
                  <Box sx={{ width: row?.width }}>
                    <InputField
                      placeholder={
                        row?.type === "number" ? "Enter Number" : "Enter Text"
                      }
                      disabled={row?.fieldName === "unit" || disabled}
                      fieldName={row?.fieldName}
                      value={
                        i === 0
                          ? formData?.totalWaterAllareas?.[row?.fieldName]
                          : formData?.waterDischargeToWaterStressAreas?.[
                              row?.fieldName
                            ]
                      }
                      handleChange={(e) =>
                        handleRowChange(
                          row?.fieldName,
                          e.target.value,
                          i,
                          row?.type
                        )
                      }
                      mt="-5px"
                    />
                  </Box>
                </Box>
              ))}
            </Box>
          )}
          {i === 0 && (
            <Box sx={{ ml: 2.5, mt: "1.5rem", mb: "-2rem" }}>
              <p className={styles.ques_heading}>
                Breakdown of total water discharge in kiloliters by the
                following types of destination (include all facility)
              </p>
            </Box>
          )}
          {i===2 && 
           <Box sx={{ ml: 2.5 ,mb: "-2rem"}}>
           <p className={styles.ques_heading}>
           Breakdown of total water discharge to areas with water stress
           in kiloliters by the following categories:
           </p>
         </Box>}
          <StaticColumn
            {...{
              inputData: el,
              tables: el[0]?.tables || [],
              setTables: el[0]?.setTables || [],
              errorField: el[0]?.errorField ,
              errors: tabErrors || {},
              setErrors: setTabErros,
              data:
                i === 0
                  ? data?.totalWaterAllareas
                  : i === 2
                  ? data?.waterDischargeToWaterStressAreas
                  : data,
              defaultSegments: el[0]?.defaultSegments,
              totalField: "quantity",
              parameter: el[0]?.paramater,
              fieldName:el?.[0]?.fieldName,
              defaultUnit,
              setDefaultUnit,
              defaultField: "unit",
              id: id,
              disabled: disabled,
              total1:i === 0
              ? formData?.totalWaterAllareas?.["total"]
              : formData?.waterDischargeToWaterStressAreas?.[
                 "total"
                ]
            }}
          />
        </Box>
      ))}
      <p className={styles.ques_heading} style={{ marginTop: hide ? "-0.5rem" : "3rem" }}>
        d. Checklist for priority substances of concern in discharges:
      </p>
      {questionData.map((el, i) => (
        <Box sx={{ mt: el?.fieldName === "contextualInformation" ? 2 : 1 }}>
          <p
            className={styles.ques_heading}
            style={{
              textIndent: i === 0 ? "-0.8rem" : "-1rem",
              marginLeft: "1rem",
              marginTop : hide ? "-1rem" : "0"
            }}
          >
            {el.title}
          </p>
          <Box sx={{ ml: 4, width: "96%" }}>
            <InputField
              placeholder={
                el?.type === "number" ? "Enter Number" : "Enter Text"
              }
              fieldName={el.fieldName}
              value={
                el?.fieldName === "contextualInformation"
                  ? formData?.[el.fieldName]
                  : formData?.checklistForPriority?.[el.fieldName]
              }
              handleChange={handleChange}
              mt="-5px"
              disabled={disabled}
            />
          </Box>
        </Box>
      ))}
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI303_4;
